var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sub_admin_icon",
    transform: "translate(20253 14052)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176070",
    "data-name": "Rectangle 176070",
    width: 28,
    height: 28,
    transform: "translate(-20253 -14052)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "admin",
    transform: "translate(-20252.582 -14051.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1526091",
    "data-name": "Path 1526091",
    d: "M91.875,78.565h-.238V76.84a2.97,2.97,0,1,0-5.94,0v1.725H85.46A1.462,1.462,0,0,0,84,80.024V82.65a2.7,2.7,0,0,0,2.7,2.7h3.929a2.7,2.7,0,0,0,2.7-2.7V80.024a1.462,1.462,0,0,0-1.459-1.459ZM86.546,76.84a2.121,2.121,0,1,1,4.243,0v1.725H86.546Zm5.94,5.81A1.856,1.856,0,0,1,90.631,84.5H86.7a1.856,1.856,0,0,1-1.854-1.854V80.024a.611.611,0,0,1,.611-.611h6.415a.611.611,0,0,1,.611.611Z",
    transform: "translate(-66.176 -58.193)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526092",
    "data-name": "Path 1526092",
    d: "M101.517,103.08a1.2,1.2,0,0,0-.424,2.333v.832a.424.424,0,0,0,.849,0v-.832a1.2,1.2,0,0,0-.424-2.333Zm0,.849a.359.359,0,1,1-.359.359A.359.359,0,0,1,101.517,103.929Z",
    transform: "translate(-79.025 -81.206)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526093",
    "data-name": "Path 1526093",
    d: "M12.309,14.3a7.107,7.107,0,0,1,5.846,3.074.424.424,0,1,0,.7-.482,7.951,7.951,0,0,0-4.381-3.135,4.586,4.586,0,1,0-4.332,0,7.961,7.961,0,0,0-5.734,6.827,11.455,11.455,0,1,1,19.357-8.273,11.581,11.581,0,0,1-.233,2.317.424.424,0,1,0,.829.172,12.3,12.3,0,1,0-7.614,8.99A.424.424,0,0,0,16.441,23,11.455,11.455,0,0,1,5.217,21.3,7.1,7.1,0,0,1,12.309,14.3ZM8.571,9.714a3.738,3.738,0,1,1,3.738,3.738A3.738,3.738,0,0,1,8.571,9.714Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubAdminIcon);
export default __webpack_public_path__ + "static/media/sub_admin_icon.4b5e6221bcb6c8871d9c2eaf3bece344.svg";
export { ForwardRef as ReactComponent };